import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard'; // 대시보드 컴포넌트
import Login from './Login'; // 로그인 컴포넌트 (로그인 후 대시보드로 리다이렉션)
import { Container } from '@mui/material';

const App = () => {
  return (
    <Router>
      <Container>
        <Routes>
          {/* 로그인 페이지 */}
          <Route path="/login" element={<Login />} />
          
          {/* 대시보드 페이지 */}
          <Route path="/dashboard" element={<Dashboard />} />
          
          {/* 기본적으로 로그인 페이지를 렌더링 */}
          <Route path="/" element={<Login />} />
        </Routes>
      </Container>
    </Router>
  );
};

export default App;
